<template>
  <div class="app-container vip-customer-page">
    <div class="vip-customer-page__panel">
      <BjPage
        ref="leftPage"
        :auto-fetch="false"
        :query-params="leftQueryParams"
        :col-span="6"
        :search-btn-span="6"
        :get-action="queryApi"
        :radio="true"
        :serial="false"
        row-key="id"
        :before-reset-search="beforeLeftResetSearch"
        @handleRadioChange="handleLeftRadioChange"
        @showSetting="showLeftSetting"
        @header-dragend="handleLeftHeaderDragend"
        @header-contextmenu="handleLeftHeaderContextmenu"
      >
        <template v-slot:baseForm>
          <el-col :span="6">
            <el-form-item :label="$t('QuotationCustomerLang.Supplier')" prop="quoteId">
              <BjInput v-model="leftQueryParams.quoteId" :placeholder="$t('QuotationCustomerLang.Supplier')" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('table.remarkText')" prop="remark">
              <BjInput v-model="leftQueryParams.remark" :placeholder="$t('table.remarkText')" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('QuotationCustomerLang.customerCode')" prop="clientCode">
              <BjInput v-model="leftQueryParams.clientCode" :placeholder="$t('QuotationCustomerLang.customerCode')" />
            </el-form-item>
          </el-col>
          <!-- 报价等级 quotationLevel： 0.普通报价。1.vip客户报价 -->
          <!-- <el-col :span="8">
            <el-form-item :label="$t('QuotationCustomerLang.Level')" prop="quotationLevel">
              <BjSelectLov v-model="leftQueryParams.quotationLevel" :placeholder="$t('QuotationCustomerLang.Level')" :option-list="quotationLevelList" @change="handleLeftQuery" />
            </el-form-item>
          </el-col> -->
        </template>

        <template v-slot:tableColumn>
          <template v-for="(col, index) in leftColumns">
            <vxe-column
              :key="`left_col_${index}_${col.prop}`"
              :field="col.prop"
              :title="col.label"
              :width="col.width || 'auto'"
              align="center"
              show-overflow
            >
              <template #default="{ row }">
                <span>{{ formatCellValue(row, col, 'left') }}</span>
              </template>
            </vxe-column>
          </template>
        </template>
      </BjPage>
    </div>

    <div class="vip-customer-page__panel" :class="{ 'is-disabled': isRightDisabled }">
      <BjPage
        ref="rightPage"
        :auto-fetch="false"
        :query-params="rightQueryParams"
        :col-span="6"
        :search-btn-span="6"
        :get-action="rightQueryApi"
        :selection="true"
        :serial="false"
        row-key="id"
        :before-reset-search="beforeRightResetSearch"
        @handleSelectionChange="handleRightSelectionChange"
        @showSetting="showRightSetting"
        @header-dragend="handleRightHeaderDragend"
        @header-contextmenu="handleRightHeaderContextmenu"
      >
        <template v-slot:baseForm>
          <el-col :span="6">
            <el-form-item :label="$t('QuotationCustomerLang.customerCode')" prop="clientCode">
              <BjInput v-model="rightQueryParams.clientCode" :maxlength="800" :placeholder="$t('QuotationCustomerLang.customerCode')" :disabled="isRightDisabled" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('QuotationCustomerLang.customerName')" prop="realName">
              <BjInput v-model="rightQueryParams.realName" :placeholder="$t('QuotationCustomerLang.customerName')" :disabled="isRightDisabled" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('QuotationCustomerLang.Status')" prop="status">
              <BjSelectLov v-model="rightQueryParams.status" :placeholder="$t('QuotationCustomerLang.Status')" :option-list="bindStatusList" :disabled="isRightDisabled" @change="handleRightQuery" />
            </el-form-item>
          </el-col>
        </template>

        <template v-slot:tableOperation="tableOperationProp">
          <el-col>
            <!-- isRightDisabled:左侧是否选中数据 、 hasSelectedStatus：判断绑定状态 、 notSelected：是否选中 -->
            <el-button type="primary" plain :disabled="isRightDisabled || tableOperationProp.notSelected || hasSelectedStatus(true)" @click="onBind">{{ $t('QuotationCustomerLang.bind') }}</el-button>
            <el-button type="primary" plain :disabled="isRightDisabled || tableOperationProp.notSelected || hasSelectedStatus(false)" @click="onUnbind">{{ $t('QuotationCustomerLang.unbind') }}</el-button>
          </el-col>
        </template>

        <template v-slot:tableColumn>
          <template v-for="(col, index) in rightColumns">
            <vxe-column
              :key="`right_col_${index}_${col.prop}`"
              :field="col.prop"
              :title="col.label"
              :width="col.width || 'auto'"
              align="center"
              show-overflow
            >
              <template #default="{ row }">
                <span>{{ formatCellValue(row, col, 'right') }}</span>
              </template>
            </vxe-column>
          </template>
        </template>
      </BjPage>
    </div>
  </div>
</template>

<script>
import { logisticApi } from '@/api';
import { quotationTimeFilter } from '@/filters';

export default {
  name: 'BusinessQuotationVIPCustomer',
  data() {
    const leftColumns = [
      { label: this.$t('QuotationCustomerLang.Supplier'), prop: 'quoteId', width: 150, isCheck: true, disabled: false },
      { label: this.$t('QuotationCustomerLang.Level'), prop: 'quotationLevel', width: 125, isCheck: true, disabled: false },
      { label: this.$t('QuotationCustomerLang.StartDate'), prop: 'startTime', width: 125, isCheck: true, disabled: false },
      { label: this.$t('QuotationCustomerLang.EndDate'), prop: 'endTime', width: 125, isCheck: true, disabled: false },
      { label: this.$t('table.remarkText'), prop: 'remark', width: 100, isCheck: true, disabled: false },
      { label: this.$t('QuotationCustomerLang.LogisticsProduct'), prop: 'productId', width: 125, isCheck: true, disabled: false },
      { label: this.$t('QuotationCustomerLang.code'), prop: 'productCode', width: 126, isCheck: true, disabled: false },
    ];
    const rightColumns = [
      { label: this.$t('QuotationCustomerLang.customerCode'), prop: 'clientCode', isCheck: true, disabled: false },
      { label: this.$t('QuotationCustomerLang.customerName'), prop: 'realName', isCheck: true, disabled: false },
      { label: this.$t('QuotationCustomerLang.salesmanName'), prop: 'csgSales', isCheck: true, disabled: false },
      { label: this.$t('QuotationCustomerLang.Status'), prop: 'matchIdsFlag', isCheck: true, disabled: false },
    ];
    return {
      selectedCustomers: [],
      selectedQuoteId: '',
      leftSortableTable: null,
      rightSortableTable: null,
      queryApi: logisticApi.getQuotesPageList,
      rightQueryApi: logisticApi.getVIPCustomerQuotes,
      tableObj: {
        title: this.$t('settingText'),
        restore: this.$t('restoreDefaultText'),
        cancel: this.$t('cancelText'),
        ok: this.$t('okText'),
        checkAll: this.$t('checkAllText'),
      },
      leftQueryParams: {
        quoteType: 1,
        quoteId: '',
        clientCode: '',
        quotationLevel: 1,
        remark: '',
      },
      rightQueryParams: {
        quoteId: '',
        customerCode: '',
        customerName: '',
        status: 0,
      },
      // 报价等级 :  0普通报价 1VIP客户报价
      quotationLevelList: [
        { label: this.$t('QuotationCustomerLang.Quotation'), value: 0 },
        { label: this.$t('QuotationCustomerLang.VIP'), value: 1 },
      ],
      logisticsProductList: [],
      leftAllColumns: leftColumns,
      leftColumns: leftColumns.filter(item => item.isCheck),
      // 右侧
      // 绑定状态 0全部 1已绑定 2未绑定
      bindStatusList: [
        { label: this.$t('QuotationCustomerLang.all'), value: 0 },
        { label: this.$t('QuotationCustomerLang.bound'), value: 1 },
        { label: this.$t('QuotationCustomerLang.unbound'), value: 2 },
      ],
      // 右侧表格列
      rightAllColumns: rightColumns,
      rightColumns: rightColumns.filter(item => item.isCheck),
    };
  },
  computed: {
    isRightDisabled() {
      return !this.selectedQuoteId;
    },
  },
  mounted() {
    this.initRouteQuery();
    this.$nextTick(this.initSortableTables);
    // 获取物流产品列表（不需要传参数）
    logisticApi.getLogisticProductList({}).then(res => {
      this.logisticsProductList = (res.content || []).map(item => ({
        label: item.productName,
        value: item.id,
        code: item.productCode,
      }));
    });
  },
  beforeDestroy() {
    this.destroySortableTable(this.leftSortableTable);
    this.destroySortableTable(this.rightSortableTable);
  },
  methods: {
    initSortableTables() {
      this.leftSortableTable = this.createSortableTable({
        pageRef: 'leftPage',
        defaultLabels: this.leftAllColumns,
        sortableTableCode: 'BusinessQuotationVIPCustomerLeft',
        handleColumn: this.handleLeftColumn,
        startIndex: 1,
      });
      this.rightSortableTable = this.createSortableTable({
        pageRef: 'rightPage',
        defaultLabels: this.rightAllColumns,
        sortableTableCode: 'BusinessQuotationVIPCustomerRight',
        handleColumn: this.handleRightColumn,
        startIndex: 1,
      });
    },
    createSortableTable({ pageRef, defaultLabels, sortableTableCode, handleColumn, startIndex }) {
      const headerRow = this.getTableHeaderRow(pageRef) || document.createElement('div');
      return this.$initElementTableSortable({
        el: headerRow,
        dragElement: '.vxe-header--column',
        defaultLabels,
        startIndex,
        sortableTableCode,
        handleColumn,
        tableObj: this.tableObj,
      });
    },
    getTableHeaderRow(pageRef) {
      return this.$refs[pageRef]?.$refs?.BjTable?.$refs?.ElTable?.$el?.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row');
    },
    destroySortableTable(sortableTable) {
      if (!sortableTable) return;
      if (sortableTable.$el && sortableTable.$el.parentNode) {
        sortableTable.$el.parentNode.removeChild(sortableTable.$el);
      }
      if (typeof sortableTable.$destroy === 'function') {
        sortableTable.$destroy();
      }
    },
    refreshTableColumn(pageRef) {
      this.$nextTick(() => {
        this.$refs[pageRef]?.$refs?.BjTable?.refreshColumn();
      });
    },
    handleLeftColumn(columns) {
      this.leftColumns = columns;
      this.refreshTableColumn('leftPage');
    },
    handleRightColumn(columns) {
      this.rightColumns = columns;
      this.refreshTableColumn('rightPage');
    },
    showLeftSetting() {
      this.leftSortableTable && this.leftSortableTable.show();
    },
    showRightSetting() {
      this.rightSortableTable && this.rightSortableTable.show();
    },
    handleLeftHeaderDragend() {
      this.leftSortableTable && this.leftSortableTable.handleHeaderDragend(...arguments);
    },
    handleRightHeaderDragend() {
      this.rightSortableTable && this.rightSortableTable.handleHeaderDragend(...arguments);
    },
    handleLeftHeaderContextmenu() {
      this.leftSortableTable && this.leftSortableTable.handleHeaderContextmenu(...arguments);
    },
    handleRightHeaderContextmenu() {
      this.rightSortableTable && this.rightSortableTable.handleHeaderContextmenu(...arguments);
    },
    initRouteQuery() {
      const { quoteId } = this.$route.query || {};
      if (!quoteId) return;

      this.leftQueryParams.quoteId = quoteId;
      this.$nextTick(() => {
        if (this.$refs.leftPage) {
          this.$refs.leftPage.fetchData(1);
        }
      });
    },
    // 过滤页面展示数据
    formatCellValue(row, col, type) {
      if (!row || !col) return '';

      const value = row[col.prop];
      if (type === 'left') {
        if (col.prop === 'quotationLevel') {
          return this.$t(this.quotationLevelList.bjGet(value));
        }
        if (col.prop === 'productId') {
          return this.logisticsProductList.bjGet(value) || '';
        }
        if (col.prop === 'startTime') {
          return value ? quotationTimeFilter(value) : '';
        }
        if (col.prop === 'endTime') {
          return value ? quotationTimeFilter(value) : '';
        }
      } else if (type === 'right') {
        if (col.prop === 'matchIdsFlag') {
          return value === true ? this.$t('QuotationCustomerLang.bound') : this.$t('QuotationCustomerLang.unbound');
        }
      }

      return value || value === 0 ? value : '';
    },
    // 左侧查询
    handleLeftQuery() {
      this.clearRightPanel();
      this.$nextTick(() => {
        if (this.$refs.leftPage) {
          this.$refs.leftPage.fetchData(1);
        }
      });
    },
    handleRightQuery() {
      if (this.isRightDisabled) return;

      this.rightQueryParams.quoteId = this.selectedQuoteId;
      this.$nextTick(() => {
        if (this.$refs.rightPage) {
          this.$refs.rightPage.fetchData(1);
        }
      });
    },
    // 左侧 选中行数据
    clearRightSelection() {
      this.selectedCustomers = [];

      if (this.$refs.rightPage) {
        this.$refs.rightPage.pageDataJson = { default: [] };
        this.$refs.rightPage.clearChange();
      }
    },
    handleLeftRadioChange(selection, row) {
      const selectedRow = row || (Array.isArray(selection) ? selection[0] : null);
      if (!selectedRow) {
        this.clearRightPanel();
        return;
      }

      this.selectedQuoteId = selectedRow ? selectedRow.id : '';
      this.rightQueryParams.quoteId = this.selectedQuoteId;
      this.clearRightSelection();

      if (this.$refs.rightPage) {
        this.$refs.rightPage.fetchData(1);
      }
    },
    clearRightPanel() {
      this.selectedQuoteId = '';
      this.rightQueryParams.quoteId = '';
      this.clearRightSelection();

      if (this.$refs.rightPage) {
        this.$refs.rightPage.tableData = [];
        this.$refs.rightPage.pagingInfo.total = 0;
      }
    },
    beforeLeftResetSearch() {
      this.clearRightPanel();
      return Promise.resolve();
    },
    beforeRightResetSearch() {
      return new Promise(resolve => {
        this.$nextTick(() => {
          this.rightQueryParams.quoteId = this.selectedQuoteId;
          resolve();
        });
      });
    },
    // 右侧 选中行数据
    handleRightSelectionChange(data) {
      this.selectedCustomers = data && Array.isArray(data.selection) ? data.selection : [];
    },
    hasSelectedStatus(status) {
      return this.selectedCustomers.some(item => item.matchIdsFlag === status);
    },
    // 右侧 绑定客户 bindVIPCustomer
    onBind() {
      if (this.isRightDisabled) return;
      const POST_DATA = {
        quoteId: this.selectedQuoteId,
        customerIds: this.selectedCustomers.map(item => item.id),
      };
      logisticApi.bindVIPCustomer(POST_DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          // 绑定成功后刷新右侧表格
          if (this.$refs.rightPage) {
            this.$refs.rightPage.fetchData(1);
          }
        }
      });
    },
    // 右侧 解绑客户 unbindVIPCustomer
    onUnbind() {
      if (this.isRightDisabled) return;
      const POST_DATA = {
        quoteId: this.selectedQuoteId,
        customerIds: this.selectedCustomers.map(item => item.id),
      };
      logisticApi.unbindVIPCustomer(POST_DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          // 解绑成功后刷新右侧表格
          if (this.$refs.rightPage) {
            this.$refs.rightPage.fetchData(1);
          }
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.vip-customer-page {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  min-height: calc(100vh - 120px);
  padding: 16px;
  background: #f3f6fa;

  &__panel {
    min-width: 0;
    padding: 16px;
    background: #fff;
    border: 1px solid #dfe7f0;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(25, 42, 70, 0.04);

    &.is-disabled {
      cursor: not-allowed;
      background: #f7f9fc;
      border-color: #e6ebf2;

      ::v-deep .bj-page {
        pointer-events: none;
        opacity: 0.55;
      }
    }
  }

  ::v-deep .bj-page {
    height: 100%;
  }
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
}
</style>
